export const DAILY_STATE_PERMISSION_CODES = {
  VIEW_SECTION: 'ESTADO_DIARIO.VER_SECCION',
  GO_TO_CAUSE: 'ESTADO_DIARIO.IR_A_CAUSA',
  MANAGE: 'ESTADO_DIARIO.GESTIONAR',
  DOWNLOAD_EXCEL: 'ESTADO_DIARIO.DESCARGAR_EXCEL',
};
